import { ChangeEvent, KeyboardEvent, useRef } from "react";
import { actionBarMinWidthWrapper } from "src/components/common/common";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";

import { useSYS4100_R01Store } from "./Store_SYS4100_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SYS4100_R01SearchSection = ({ onEnterKeyDown }: Props) => {

	const { SYS4100_R01Filter, setSYS4100_R01Filter } = useSYS4100_R01Store();
	const { yesNoList } = useCommonCodeStore();

  return (
    <SearchSectionForm>
		{/* SYS4100_R01Filter : {JSON.stringify(SYS4100_R01Filter)} */}
		<SearchInputForm
			label="부서명/코드"
			value={SYS4100_R01Filter.orgNm}
			onChange={(e) => setSYS4100_R01Filter({ orgNm: e.target.value })}
			initValue={() => setSYS4100_R01Filter({ orgNm: '' })}
			onKeyDown={onEnterKeyDown}
			wrapperOption={{
				titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[60px] min	-w-[60px]",
				inputStyle: "w-[180px] min-w-[180px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]",
			}}
		/>
		
		<SearchDropDownForm
			label="사용여부"
			value={SYS4100_R01Filter.useYn}
			optionList={yesNoList}
			onChangeItem={(selectedItem) => setSYS4100_R01Filter({ useYn: selectedItem?.minorCd || '' })}
		/>
	</SearchSectionForm>
  );
};